import { Dropdown } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { selectedMetadataAtom } from '../../atoms/selectedMetadata';
import { findPeriodDisplayValue } from '../Period/Period';
import { NFL_IDENTIFIER } from '../Sport/Sport';

export function MatchPart({ size }) {
  const intl = useIntl();

  const [selectedMetadata, setSelectedMetadata] = useAtom(selectedMetadataAtom);

  const soccerOptions = ['1', '2', '3', '4', '5'].map((period) => ({
    label: findPeriodDisplayValue(intl, period, selectedMetadata.sport),
    value: period.toString(),
  }));
  const amfOptions = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
  ].map((period) => ({
    label: findPeriodDisplayValue(intl, period, selectedMetadata.sport),
    value: period.toString(),
  }));

  const options =
    selectedMetadata?.sport === NFL_IDENTIFIER ? amfOptions : soccerOptions;

  return (
    <Dropdown
      id="period-select"
      label={intl.formatMessage({ defaultMessage: 'Period', id: '19016' })}
      labelPosition="top"
      onChange={(selected) =>
        setSelectedMetadata({ ...selectedMetadata, period: selected.value })
      }
      options={options}
      placeholder={intl.formatMessage({
        defaultMessage: 'Period',
        id: '19016',
      })}
      size={size}
      value={options.find((option) => option.value === selectedMetadata.period)}
      variant="secondary"
    />
  );
}
MatchPart.propTypes = {
  size: PropTypes.string,
};
MatchPart.defaultProps = {
  size: undefined,
};

export default { MatchPart };
